import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#0f0f1a]">
      <Header />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-xl mx-auto text-center">
          <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-red-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">
            Pagamento Annullato
          </h1>
          
          <p className="text-gray-300 text-lg mb-8">
            Il pagamento è stato annullato. Nessun addebito è stato effettuato.
          </p>

          <div className="bg-[#1a1a2e] rounded-xl p-6 mb-8 text-left border border-gray-700">
            <h2 className="text-lg font-semibold text-white mb-3">Hai bisogno di aiuto?</h2>
            <p className="text-gray-400 mb-4">
              Se hai riscontrato problemi durante il pagamento o hai domande sui nostri servizi, 
              non esitare a contattarci.
            </p>
            <a 
              href="mailto:cyber@smart-info.it"
              className="text-cyan-400 hover:text-cyan-300 transition-colors"
            >
              cyber@smart-info.it
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Torna alla Home
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="px-6 py-3 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-lg font-medium hover:opacity-90 transition-all flex items-center justify-center gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Riprova
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentCancelPage;
